import { Component, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import moment from 'moment';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { map, Observable, of } from 'rxjs';

import { GridSearchEntityInstance } from '@models/module/grid';
import { CalendarBaseViewComponent } from '@module-instance/calendar/calendar-base-view.component';
import { CalendarDocMiniComponent } from '@module-instance/calendar/calendar-doc-mini/calendar-doc-mini.component';
import {
  CalendarDate,
  CalendarTile,
  CalendarTileDoc,
  CalendarViewMode,
} from '@module-instance/calendar/calendar.model';

@Component({
  selector: 'app-calendar-year-view',
  templateUrl: './calendar-year-view.component.html',
  styleUrls: ['./calendar-year-view.component.scss'],
  imports: [NgxSkeletonLoaderModule, CalendarDocMiniComponent, TranslateModule, MatButtonModule],
})
export class CalendarYearViewComponent extends CalendarBaseViewComponent {
  readonly onMonthClick = output<CalendarDate>();

  monthClick(date: Date) {
    const dt = moment(date);
    const calendarDate = {
      date: dt.toDate(),
      year: dt.year(),
      month: dt.month(),
      week: dt.isoWeek(),
      day: dt.date(),
    };
    this.onMonthClick.emit(calendarDate);
  }

  getTiles(empty: boolean, docs?: GridSearchEntityInstance[]): Observable<CalendarTile[]> {
    const result: CalendarTile[] = [];

    const day = moment(new Date(this.date().year, 0, 1));

    return of(empty ? [] : this.processDocs(CalendarViewMode.Month, docs)).pipe(
      map((processedDocs: CalendarTileDoc[]) => {
        this.startDate = day.toDate();
        for (let i = 0; i < 12; i++) {
          const dt = day.toDate();
          const dtMonth = day.month();
          const monthName = day.format('MMMM');
          const isToday = this.date().month == dtMonth;

          const tile = {
            viewMode: CalendarViewMode.Year,
            date: dt,
            year: this.date().year,
            month: dtMonth,
            week: day.isoWeek(),
            day: 1,
            text: monthName,
            isToday: isToday,
            docs: [],
          } as CalendarTile;
          if (!empty) {
            tile.docs = this.getTileDocs(tile, processedDocs);
          }
          result.push(tile);

          day.add(1, 'M');
        }
        this.endDate = day.toDate();
        return result;
      }),
    );
  }

  getTileDocs(tile: CalendarTile, docs: CalendarTileDoc[]): CalendarTileDoc[] {
    const found = (docs || []).filter(d => d.ref.year === tile.year && d.ref.month === tile.month);
    return found;
  }
}
